import React, { useEffect, useState } from 'react'
import { rbsApi } from '../api/rbsApi'
import { useTranslation } from 'react-i18next';

export const useRating = (url, object=null) => {

    const [t, i18n] = useTranslation("global");
  
    const [state, setState] = useState(
        {
            data: null,
            isLoading: true,
            error: null
        }
    )

    const postAxios = async () => {
        setState({
            ...state,
            isLoading: true
        })

        try{
           const { data } = rbsApi.post(url, object)
                .then( () => {
                    setState(
                        {
                            data: data,
                            isLoading: false,
                            error: null,
                        }
                    );
                    alert(t('axios.gracias'));
                })
                .catch( error => {
                    setState({
                        data: null,
                        isLoading: false,
                        error: error,
                      });
                });
           
        } catch (error) {
            setState({
              data: null,
              isLoading: false,
              error: error,
            });
        } 
            
    }

    useEffect(() => {
      if( !url ){
        setState({
              data: null,
              isLoading: false,
              error: null,
            });

            return;
        };
        postAxios();
    }, [url])
  
    return {
        data:  state.data,
        isLoading: state.isLoading,
        error: state.error
    }
}
